'use strict';

module.exports = 'year|month|week|day|hour|minute|second|millisecond';


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/var/DURATION_UNITS.js
// module id = 112
// module chunks = 0